import { Injectable, inject } from '@angular/core';
import { filter, firstValueFrom } from 'rxjs';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { AlertService } from './alert.service';

@Injectable({ providedIn: 'root' })
export class PromptUpdateService {
  constructor() {
    const swUpdate = inject(SwUpdate);
    const alertService = inject(AlertService);

    swUpdate.versionUpdates
      .pipe(
        filter(
          (evt): evt is VersionReadyEvent =>
            evt.type === 'VERSION_READY'
        )
      )
      .subscribe(async () => {
        const shouldReload = await firstValueFrom(
          alertService.confirm({
            title: 'Доступно обновление',
            message: 'Обновить страницу сейчас?',
            confirmButtonText: 'Обновить',
            cancelButtonText: 'Позже',
          })
        );
        if (shouldReload) {
          document.location.reload();
        }
      });
  }
}

